import React, { Component } from 'react';

import { Link } from 'react-router-dom';

class ResultCTA extends Component {
  shouldRender = () => {
    return true;
  };
  render() {
    if (this.props.areResultsOwnedByUser) {
      return null;
    }

    return (
      <div className="ResultsCTA">
        <h2>Where should you go to university?</h2>
        <p>
          Find out your own results. In just 10 minutes, we can help you make a
          more informed decision about a school and program that is best suited
          to your skills, goals, and interests.
        </p>
        <Link to="/survey/" className="ResultsCTA-button">
          Get Started
        </Link>
      </div>
    );
  }
}

export default ResultCTA;



// WEBPACK FOOTER //
// ./src/Components/Pages/Results/ResultCTA.js